import styled from "styled-components";

export const Row = styled.div`
    > div {
        height: 4rem;
        border: 1px solid black;
        display: flex;
        align-items: center;
        font-weight: 800;
    }
`